import { makeStyles, Tab, Tabs } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import React, { Fragment, memo, useCallback, useState } from 'react';
import { useObservable } from 'react-use-observable';
import HelperPage from 'v2/components/Shared/HelperPage';
import Tour from 'v2/components/Shared/Tour';
import refundService from 'v2/services/requestManagement/refund';

import Refund from './Refund';
import { steps } from './tour';

const useStyles = makeStyles(() => ({
  content: {},
  tabs: {
    marginBottom: 16,
  },
  tab: {
    minWidth: 110,
  },
  notificationsBadge: {
    top: '13px',
    left: '-6px',
    position: 'relative',
    backgroundColor: 'red',
    color: '#ffffff',
  },
}));

export type IRequestManagementTabs = 'refund' | 'dispute' | 'partnership';

const RequestManagement = memo(() => {
  const classes = useStyles();

  const [pagination] = useObservable(() => {
    return refundService.getPaginationResponse();
  }, []);

  const [tab, setTab] = useState<IRequestManagementTabs>('refund');

  const handleChange = useCallback((_: React.ChangeEvent<{}>, tab: IRequestManagementTabs) => {
    setTab(tab);
  }, []);

  return (
    <Fragment>
      {!!pagination?.total_items && <Tour name='pending_actions_tour' steps={steps} />}
      <div>
        <Grid id='my-subscriptions' container justify='space-between' alignItems='flex-start'>
          <div className='my-title'>
            <h1>Ações pendentes</h1>
            <p>Consulte todas as ações pendentes e gerencie suas solicitações</p>
          </div>
          <HelperPage id='helper_request_management_button' title='Solicitações de Reembolso' name='request_management_refund' />
        </Grid>

        <div className='m32' />

        <div>
          <Tabs className={classes.tabs} onChange={handleChange} value={tab} indicatorColor='primary' textColor='primary'>
            <Tab
              className={classes.tab}
              value='refund'
              label={
                <Badge classes={{ badge: classes.notificationsBadge }} showZero={false} badgeContent={pagination?.total_items || 0}>
                  Reembolsos
                </Badge>
              }
            />
            {/* <Tab className={classes.tab} value='dispute' label='Disputas' />
            <Tab className={classes.tab} value='partnership' label='Parcerias' /> */}
          </Tabs>
          {tab === 'refund' && <Refund />}
        </div>
      </div>
    </Fragment>
  );
});

export default RequestManagement;
